/**
 * Mega menu hover disclosure (motto-style details/summary).
 */
(function () {
  const OPEN_DELAY = 100;
  const CLOSE_DELAY = 150;
  const SWITCH_DELAY = 0;

  function isAnyMegaMenuOpen(header) {
    return Array.from(header.querySelectorAll('[data-mega-menu-disclosure]')).some((details) => {
      return details.hasAttribute('open') || details.querySelector('.mega-menu.active');
    });
  }

  function closeAllMegaMenus(header, exceptDetails) {
    header.querySelectorAll('[data-mega-menu-disclosure]').forEach((details) => {
      if (details === exceptDetails) return;

      details.removeAttribute('open');
      const megaMenu = details.querySelector('.mega-menu[data-parent-link]');
      if (megaMenu) megaMenu.classList.remove('active');
    });
  }

  function updateHeaderState(header) {
    const anyOpen = isAnyMegaMenuOpen(header);

    if (anyOpen) {
      header.classList.add('site-header--menu-opened');
    } else {
      header.classList.remove('site-header--menu-opened');
    }
  }

  function isHoveringMenuSystem(details, megaMenu, summary) {
    return (
      details.matches(':hover') ||
      megaMenu.matches(':hover') ||
      (summary && summary.matches(':hover'))
    );
  }

  function setupMegaMenuDisclosure(header, details) {
    if (details.dataset.megaMenuReady) return;
    details.dataset.megaMenuReady = 'true';

    const megaMenu = details.querySelector('.mega-menu[data-parent-link]');
    const summary = details.querySelector('summary');
    if (!megaMenu || !summary) return;

    let openTimeout = null;
    let closeTimeout = null;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
    });

    const topLink = summary.querySelector('[data-top-link]');
    if (topLink) {
      topLink.addEventListener('click', (event) => {
        event.stopPropagation();

        const href = topLink.getAttribute('href');
        if (!href || href === '#') return;

        if (!event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
          event.preventDefault();
          closeAllMegaMenus(header);
          updateHeaderState(header);
          window.location.assign(href);
        }
      });
    }

    const openMenu = () => {
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }

      const anyOpen = isAnyMegaMenuOpen(header);
      const delay = anyOpen ? SWITCH_DELAY : OPEN_DELAY;

      const performOpen = () => {
        closeAllMegaMenus(header, details);
        megaMenu.classList.add('active');
        details.setAttribute('open', '');
        updateHeaderState(header);
        openTimeout = null;
      };

      if (delay === 0) {
        performOpen();
      } else {
        openTimeout = setTimeout(performOpen, delay);
      }
    };

    const scheduleClose = () => {
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
      if (closeTimeout) clearTimeout(closeTimeout);

      closeTimeout = setTimeout(() => {
        if (!isHoveringMenuSystem(details, megaMenu, summary)) {
          megaMenu.classList.remove('active');
          details.removeAttribute('open');
          updateHeaderState(header);
        }
        closeTimeout = null;
      }, CLOSE_DELAY);
    };

    const cancelOpen = () => {
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
    };

    const onSummaryMouseLeave = (event) => {
      const related = event.relatedTarget;
      if (related instanceof Node) {
        if (details.contains(related) || megaMenu.contains(related)) return;
      }
      cancelOpen();
      scheduleClose();
    };

    const onPanelMouseLeave = (event) => {
      const related = event.relatedTarget;
      if (related instanceof Node) {
        if (summary.contains(related) || details.contains(related)) return;
      }
      scheduleClose();
    };

    summary.addEventListener('mouseenter', openMenu);
    summary.addEventListener('mouseleave', onSummaryMouseLeave);
    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', onSummaryMouseLeave);
    megaMenu.addEventListener('mouseenter', openMenu);
    megaMenu.addEventListener('mouseleave', onPanelMouseLeave);
  }

  function initMegaMenuDisclosures() {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    header.querySelectorAll('[data-mega-menu-disclosure]').forEach((details) => {
      setupMegaMenuDisclosure(header, details);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('[data-mega-menu-disclosure]')) {
            setupMegaMenuDisclosure(header, node);
          }
          node.querySelectorAll('[data-mega-menu-disclosure]').forEach((details) => {
            setupMegaMenuDisclosure(header, details);
          });
        });
      });
    });

    observer.observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuDisclosures);
  } else {
    initMegaMenuDisclosures();
  }

  document.addEventListener('shopify:section:load', initMegaMenuDisclosures);
})();
